
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#400F3F","rx":"16"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#FF4702","d":"M64.312 71.824c-1.19.678-2.876.678-4.065 0L39.92 60.258c-1.19-.678-2.843-.678-4.032 0-1.686.968-1.686 2.83 0 3.799L58.23 76.785c2.38 1.355 5.717 1.355 8.13 0l22.342-12.728c1.686-.968 1.686-2.831 0-3.8l-.033-.023c-1.19-.678-2.842-.678-4.032 0l-20.326 11.59zm0 11.954c-1.19.677-2.876.677-4.065 0L39.92 72.21c-1.19-.677-2.843-.677-4.032 0-1.686.968-1.686 2.831 0 3.8L58.23 88.737c2.38 1.355 5.717 1.355 8.13 0L88.703 76.01c1.686-.968 1.686-2.83 0-3.799l-.033-.024c-1.19-.677-2.842-.677-4.032 0l-20.326 11.59zm2.082-19.261l22.342-12.728c1.686-.968 1.686-2.856 0-3.824L66.394 35.238c-2.38-1.356-5.718-1.356-8.13 0L35.922 47.99c-1.686.968-1.686 2.855 0 3.823L58.264 64.54c2.38 1.355 5.75 1.355 8.13-.024z"}}),_c('path',{attrs:{"fill":"#661A32","stroke":"#FF4702","stroke-width":"4","d":"M65.391 62.786l.013-.007L87.74 50.054c.347-.199.347-.155.006-.35L65.404 36.975c-1.767-1.007-4.358-1.007-6.149-.001l-22.337 12.75c-.347.2-.347.155-.006.351l22.341 12.728c1.769 1.007 4.381 1.001 6.138-.017z"}})])])])
          )
        }
      }
    